/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_W1Inputs */

const en_mk_cmp_multica_w1 = /** @type {(inputs: Mk_Cmp_Multica_W1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your team is an engineering team and the work you want to delegate really is writing code.`)
};

const id_mk_cmp_multica_w1 = /** @type {(inputs: Mk_Cmp_Multica_W1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim Anda adalah tim engineering dan pekerjaan yang ingin didelegasikan memang menulis kode.`)
};

/**
* | output |
* | --- |
* | "Your team is an engineering team and the work you want to delegate really is writing code." |
*
* @param {Mk_Cmp_Multica_W1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_w1 = /** @type {((inputs?: Mk_Cmp_Multica_W1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_W1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_w1(inputs)
	return en_mk_cmp_multica_w1(inputs)
});